import * as React from 'react';
import { EditState, EditProps, BaseRouteProps } from '../../../interfaces';
import { ScoreCard, ScoreCardGroup } from '../../../models';
import { ScoreCardDataService } from '../../../services';
import { NavLink } from 'react-router-dom';
import { TopNavMenu } from '../../navigation/TopNavMenu';
import { ScoreCardForm } from './ScoreCardForm';
import { LoadingIndicator, PVAPage } from '../../../components';
import { UserStore } from '../../../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';

interface ScoreCardEditProps extends BaseRouteProps<EditProps> {
    UserStore?: UserStore;
}

interface ScoreCardEditState extends EditState<ScoreCard> {
    loading: boolean;
}

@inject('UserStore') @observer
export class ScoreCardEdit extends React.Component<ScoreCardEditProps, ScoreCardEditState> {
    private scoreCardDataService = new ScoreCardDataService(this.props.notificationService);

    @computed get userLanguage() {
        return this.props.UserStore!.userInfo.language;
    }

    constructor(props: ScoreCardEditProps) {
        super(props);

        this.state = {
            originalEntity: undefined,
            loading: false
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        const id = this.props.match.params.id;

        if (id) {
            this.scoreCardDataService.get(id).then((scoreCard: ScoreCard) => {
                this.setState({ originalEntity: scoreCard });
            }).catch((response) => {
                this.props.history.push({
                    pathname: '/error',
                    state: {
                        code: response.status,
                        entityType: 'score card'
                    }
                });
            });
        }
    }

    public render() {
        if (!this.state.originalEntity || this.state.loading) {
            return <LoadingIndicator />;
        }

        return (
            <PVAPage>
                <TopNavMenu open={true} />

                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={'/scorecards'}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp; 
                        Edit Score Card
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <ScoreCardForm defaultValues={this.state.originalEntity} submit={(e: any) => this.save(e)} />

                    <div className="row">
                        <div className="col-xs-8">
                            <h3>Groups</h3>
                        </div>
                        <div className="col-xs-4 text-right">
                            <NavLink className="btn btn-default" to={`/scorecards/${this.props.match.params.id}/groups/create`}>
                                Create
                            </NavLink>
                        </div>
                    </div>
                    <table className="table table-striped">
                        <tbody>
                            {this.state.originalEntity.scoreCardGroups.map((group: ScoreCardGroup) => {
                                return <tr key={`group-${group.id}`}>
                                    <td>{group.name}</td>
                                    <td className="text-right">
                                        <NavLink className="btn btn-default" to={`/scorecards/${this.props.match.params.id}/groups/${group.id}`}>
                                            Edit
                                        </NavLink>
                                    </td>
                                </tr>;
                            })}
                        </tbody>
                    </table>
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.scoreCardDataService.update(values).then((success) => {
            this.props.history.push('/scorecards');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCard/ScoreCardEdit.tsx